export class SearchResult {
    placeIdentifier: string;
    displayIdentifier: string;
    resultType: string;
    longitude: number;
    latitude: number;
    zoomLevel: number;
}
